module.exports = __webpack_public_path__ + "media/images/anoreg_contato-d52cb502eb00fbf9b2d7443058b2875a.png";